import { render, staticRenderFns } from "./StatisticType.vue?vue&type=template&id=e12d0e24&scoped=true"
import script from "./StatisticType.vue?vue&type=script&lang=js"
export * from "./StatisticType.vue?vue&type=script&lang=js"
import style0 from "./StatisticType.vue?vue&type=style&index=0&id=e12d0e24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12d0e24",
  null
  
)

export default component.exports